// Restructured to nested form to match component usage
// (`t('list.title')`, `t('createTournament.basicInfo.title')`, etc.).
export const tournament = {
  // ---------------- Tournament List page ----------------
  list: {
    title: "Tournaments",
    totalTournaments: "{{count}} total tournaments",
    new: "New",
    getStarted: "Get Started",
    createNew: "Create New Tournament",
    setupFormat: "Set up elimination or round robin format",
    createTournament: "Create Tournament",
    noTournaments: "Can't find a suitable tournament?",
    noFilteredTournaments: "No {{filter}} tournaments",
    noFilteredDescription: "You don't have any {{filter}} tournaments right now.",
    createFirst: "Try searching other areas, or create one yourself.",
    deleteConfirm: "Are you sure you want to delete this tournament?",
    progress: "Progress",
    matches: "{{completed}} / {{total}} matches",
    created: "Created",
    view: "View",
    noLocation: "No location",
    singleElimination: "Single Elimination",
    roundRobin: "Round Robin",
    players: "{{count}} players",
    filter: {
      all: "All",
      active: "Active",
      completed: "Completed",
    },
    status: {
      upcoming: "Upcoming",
      open: "Signups Open",
      inProgress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled",
    },
  },

  // ---------------- Create Tournament page ----------------
  createTournament: {
    title: "Create Tournament",
    subtitle: "Set up a new tournament",
    nextStep: "Next: Add Participants",
    publishCta: "Create & Publish",
    rankedTitle: "Acework Ranked",
    rankedSubtitle: "Tag this tournament so wins count toward the official Acework rating and city leaderboard.",
    rankedToggle: "Acework Ranked Tournament",
    rankedHint: "Wins are submitted for double-confirmation and earn points by skill level.",
    proOnly: "Pro+",

    basicInfo: {
      title: "Basic Information",
      name: "Tournament Name",
      namePlaceholder: "e.g., Spring Championship 2026",
      location: "Location",
      locationPlaceholder: "e.g., Central Park Tennis Club",
      date: "Start Date",
    },

    format: {
      title: "Tournament Format",
      type: "Format Type",
      elimination: "Single Elimination",
      eliminationDesc: "Knockout format",
      roundRobin: "Round Robin",
      roundRobinDesc: "Group stage",
      drawSize: "Draw Size",
      groupSize: "Total Players",
      numberOfSeeds: "Number of Seeded Players",
      seedsInfo:
        "Seeds 1 & 2 will be placed in opposite halves of the draw.",
    },

    matchSettings: {
      title: "Match Settings",
      category: "Match Category",
      categories: {
        mens_singles: "Men's Singles",
        womens_singles: "Women's Singles",
        mens_doubles: "Men's Doubles",
        womens_doubles: "Women's Doubles",
        mixed_doubles: "Mixed Doubles",
        rally: "Rally",
        group: "Group (open, no cap)",
      },
      matchFormat: "Match Length",
      bestOf1: "1 Set",
      bestOf3: "Best of 3",
      bestOf5: "Best of 5",
      gamesPerSet: "Games per Set",
      gamesPerSetHint: "Standard sets are first to 6. 4-game sets are common in club / amateur play. Tiebreak = super tiebreak decides the whole match.",
      games6: "First to 6",
      games4: "First to 4",
      gamesTiebreak: "Match Tiebreak",
      deuceRule: "Deuce Rule (40-40)",
      deuceRuleHint: "Golden point ends the deuce immediately — next point wins. Advantage requires winning by 2.",
      deuce: {
        advantage: "Advantage",
        goldenPoint: "Golden Point",
      },
      tiebreak: "Tiebreak Format",
      points7: "First to 7",
      points10: "First to 10",
    },

    summary: {
      title: "Tournament Summary",
      subtitle: "Review your settings",
      name: "Name",
      notSet: "Not set",
      format: "Format",
      drawSize: "Draw Size",
      groupSize: "Total Players",
      players: "players",
      seededPlayers: "Seeded Players",
      seeds: "seeds",
      matchFormat: "Match Format",
      bestOf: "Best of",
      tiebreak: "Tiebreak",
      points: "points",
    },

    participants: {
      title: "Add Participants",
      players: "players",
      seeds: "seeds",
      addPlayer: "Search for a player",
      searchHint: "Only registered Acework users can join. Search by handle or display name.",
      searchPlaceholder: "Search by @handle or name…",
      addBye: "Add BYE (Walkover)",
      makeSeed: "Make Seed",
      unseed: "Unseed",
      seededPlayers: "Seeded Players",
      seedNumber: "Seed #{{number}}",
      unseededPlayers: "Unseeded Players",
      walkover: "Walkover",
      noParticipants: "Search above to add players. Only registered users can be added.",
      backToSettings: "Back to Settings",
      createTournament: "Create Tournament",
    },

    validation: {
      nameRequired: "Tournament name is required",
      maxPlayers: "Maximum {{max}} players allowed for this draw size",
      maxSeeds: "Maximum {{max}} seeded players allowed",
      minParticipants: "Please add at least 2 participants",
      allSeeds:
        "Please add all {{required}} seeded players before creating",
      loginRequired: "Please sign in to create a tournament",
      rankedPaidOnly: "Acework Ranked tournaments are a Pro / Elite feature. Upgrade to host ranked tournaments.",
      rankedDrawTooBig: "Your tier supports Acework Ranked up to {{cap}}-player brackets. Upgrade to Elite for larger draws.",
    },
  },

  // ---------------- Tournament Bracket page ----------------
  bracket: {
    title: "Tournament Bracket",
    progress: "Tournament Progress",
    champion: "Champion",
    tournamentChampion: "Tournament Champion",
    playerDraw: "Player Draw",
    matchDetails: "Match Details",
    bestOfSets: "Best of",
    sets: "Sets",
    diagram: "Tournament Bracket Diagram",
    round: "Round",
    final: "Final",
    semifinals: "Semifinals",
    quarterfinals: "Quarterfinals",
    winner: "Winner",
    draw: "Draw",
    format: "Format",
    roundRobinFormat: "Round Robin Format",
    allMatches: "All Matches",
    tapToEnterScore: "Tap to enter score",
    completeRoundAdvance: "Complete Round & Advance",
    advance: "Advance",
  },

  // ---------------- Tournament History page ----------------
  history: {
    title: "Tournament History",
    viewAll: "View all tournaments",
    notFound: "No Tournaments Found",
  },

  // ---------------- Top-level shortcuts ----------------
  // Some UI bits (chips, buttons) reach for these directly.
  tournaments: "Tournaments",
  matches: "matches",
  cancel: "Cancel",
  live: "LIVE",
};
